var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEnquiryIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_447_1",
    "data-name": "Component 447 \\u2013 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7744",
    "data-name": "Rectangle 7744",
    width: 32,
    height: 32,
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_30251",
    "data-name": "Path 30251",
    d: "M106.74-847.252h8.424v-.412a2.035,2.035,0,0,0-1.174-1.78,5.945,5.945,0,0,0-3.038-.689,5.945,5.945,0,0,0-3.038.689,2.035,2.035,0,0,0-1.174,1.78Zm4.212-4.39a1.946,1.946,0,0,0,1.429-.589,1.946,1.946,0,0,0,.589-1.429,1.946,1.946,0,0,0-.589-1.429,1.946,1.946,0,0,0-1.429-.589,1.946,1.946,0,0,0-1.429.589,1.946,1.946,0,0,0-.589,1.429,1.946,1.946,0,0,0,.589,1.429A1.946,1.946,0,0,0,110.952-851.642ZM100-838.628v-19.288a2.012,2.012,0,0,1,.605-1.479,2.012,2.012,0,0,1,1.479-.605H119.82a2.012,2.012,0,0,1,1.479.605,2.012,2.012,0,0,1,.605,1.479v13.124a2.012,2.012,0,0,1-.605,1.479,2.012,2.012,0,0,1-1.479.605h-15.74Zm3.343-5.809H119.82a.338.338,0,0,0,.244-.111.338.338,0,0,0,.111-.244v-13.124a.338.338,0,0,0-.111-.244.338.338,0,0,0-.244-.111H102.084a.338.338,0,0,0-.244.111.338.338,0,0,0-.111.244v15.075Zm-1.614,0v0Z",
    transform: "translate(-94.958 865.065)",
    fill: "#707070"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnquiryIcon);
export default __webpack_public_path__ + "static/media/EnquiryIcon.4f4095e5168b758ef9fe21c6ced079bd.svg";
export { ForwardRef as ReactComponent };